import { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';
import {
  type Appearance,
  type KaiShikiContextValue,
  mergeProviderValue,
  type ProviderValue,
  resolveProviderValue,
} from '../core/theme';

const KaiShikiContext = createContext<KaiShikiContextValue | null>(null);

export interface KaiShikiProviderProps extends PropsWithChildren {
  value?: ProviderValue;
  appearance?: Appearance;
}

export const KaiShikiProvider = ({
  children,
  value,
  appearance,
}: KaiShikiProviderProps) => {
  const parentValue = useContext(KaiShikiContext);
  const effectiveValue: ProviderValue | undefined = appearance !== undefined ? { ...value, appearance } : value;
  const resolvedValue = parentValue
    ? mergeProviderValue(parentValue, effectiveValue)
    : resolveProviderValue(effectiveValue);

  return (
    <KaiShikiContext.Provider value={resolvedValue}>
      {children}
    </KaiShikiContext.Provider>
  );
};

export const useKaiShikiProviderValue = (): KaiShikiContextValue => useContext(KaiShikiContext) ?? resolveProviderValue();

export const useKaiShikiContext = useKaiShikiProviderValue;
